import { zfd } from 'zod-form-data';
import { ClaimType } from '~/utils/constants';
import { makeCrewAction, redirect } from '~/utils/routing';
import { addressFormSchema, addressSchemaRequiredPhone } from '~/utils/schemas';
import { isAddressPhoneRequired } from '~/utils/theme';

export const { action, useActionResult: useAddressActionResult } =
  makeCrewAction(({ formData, context }, appState) => {
    const formSchema =
      isAddressPhoneRequired(context.settings.theme, context.claimType) ?
        addressSchemaRequiredPhone
      : addressFormSchema;

    const result = zfd.formData(formSchema).safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Invalid address. Please update your address.',
      };
    }

    appState.dispatch(appState.actions.crewClaim.setAddress(result.data));

    return redirect(
      context.claimType === ClaimType.warranty ?
        `../review/warranty`
      : `../return-methods`,
    );
  });
